import {
  drawer_end_styles_default
} from "./chunk.6XMPYBUR.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/drawer/drawer-end.ts
var FadvDrawerEnd = class extends s {
  constructor() {
    super(...arguments);
    this.isOpen = false;
  }
  open() {
    this.isOpen = true;
  }
  close() {
    this.isOpen = false;
  }
  render() {
    return $`<div class=${o({
      "drawer-end": true,
      "drawer-end--open": this.isOpen
    })} ><slot></slot></div>`;
  }
};
FadvDrawerEnd.styles = drawer_end_styles_default;
__decorateClass([
  t()
], FadvDrawerEnd.prototype, "isOpen", 2);
FadvDrawerEnd = __decorateClass([
  n("fadv-drawer-end")
], FadvDrawerEnd);

export {
  FadvDrawerEnd
};
